import classNames from "classnames";
import React from "react";
import { SvgIcon as RootSvgIcon } from "./SvgIcon";

export type StreamLineIcons =
  | "s-arrow-up"
  | "s-arrow-down"
  | "s-arrow-left-dash"
  | "s-arrow-left"
  | "s-arrow-right-dash"
  | "s-arrow-right"
  | "s-arrow-right-dash-with-padding"
  | "s-attachment"
  | "s-calendar"
  | "s-close-small"
  | "s-close"
  | "s-close-with-padding"
  | "s-disabled"
  | "s-edit"
  | "s-info-circle"
  | "s-login"
  | "s-login-light"
  | "s-login-key"
  | "s-logout"
  | "s-mail"
  | "s-mail-bold"
  | "s-pin-light"
  | "s-pin"
  | "s-phone"
  | "s-search-light"
  | "s-search"
  | "s-star"
  | "s-star-filled"
  | "s-upload"
  | "s-user"
  | "s-view-off"
  | "s-view-on"
  | "s-plus"
  | "s-checkmark"
  | "s-trash"

interface SvgIconProps {
  iconName: StreamLineIcons;
  alternativeText?: string;
  className?: string;
  svgClassName?: string
}

export const StreamLineIcon: React.FC<SvgIconProps> = (props) => {
  const { iconName, alternativeText, className } = props;
  return (
    <span className={classNames('insuranceSvgIcon', className)}>
      <RootSvgIcon<StreamLineIcons> iconName={iconName} alternativeText={alternativeText} />
    </span>
  );
};
